export default __webpack_public_path__ + "static/media/support_avatar.68b57de1.png";